let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fNNxo")).then(() => parcelRequire('6vcJA'));